<script lang="ts">
  export let name;
  export let avatarImageUrl;
  export let title;
  export let bio;
  export let socialTwitter;
  export let socialInstagram;
  export let socialFacebook;
</script>

<div class="col-md-4">
  <div class="team-player">
    <div class="card card-plain">
      <div class="col-md-6 ml-auto mr-auto">
        <img
          src={avatarImageUrl}
          alt="Thumbnail Image"
          class="img-raised rounded-circle img-fluid" style="width: 200px"/>
      </div>
      <h4 class="card-title">
        {name}
        <br />
        <small class="card-description text-muted">{title}</small>
      </h4>
      {#if bio}
        <div class="card-body">
          <p class="card-description">
            {bio}
          </p>
        </div>
      {/if}
    </div>
  </div>
</div>
